import type { StoreConfig } from './types'

/**
 * Values the bundle needs before `/api/bootstrap` answers. hydrateConfig()
 * replaces them from D1 at startup (see src/lib/bootstrap.ts); what is below is
 * the build-time default and the fallback when the API is unreachable.
 *
 * The public site shows no prices, so it reads none of these itself. The admin
 * panel shares the bundle and does: the rate for its price hints and lekë
 * figures, the threshold for its low-stock badges.
 */

/** EUR -> ALL, as set in Admin → Settings. */
export let EUR_TO_ALL = 97.5

/** Below this many units the admin panel marks a product "low stock". */
export let LOW_STOCK_THRESHOLD = 10

/** Applied once at startup from `/api/bootstrap`, and again when Settings are saved. */
export function hydrateConfig(config: StoreConfig): void {
  EUR_TO_ALL = config.eurToAll
  LOW_STOCK_THRESHOLD = config.lowStockThreshold
}

export const PAGE_SIZE = 9

export { COMPANY } from './lib/shared/company'
